// ***************************************
// Data loading service for notes 
// ***************************************

import { apiClient } from "./apiClient";

export async function fetchNotesApi({ workspaceId, token }) {
  return apiClient(`/notes/workspace/${workspaceId}`, {
    token,
    method: "GET",
  });  
}

export async function fetchNotesGeneralApi({ workspaceId, token }) {
  return apiClient(`/notes/general/${workspaceId}`, {
    token,
    method: "GET",
  });  
}

// ---------- POST create new event ----------
export async function createNoteApi({ token, event }) {
  return apiClient(`/notes`, {
    token,
    method: "POST",
    body: event,
  });
}

// ---------- PUT update existing event ----------
export async function updateNoteApi({ token, id, event }) {
  return apiClient(`/notes/${id}`, {
    token,
    method: "PUT",
    body: event,
  });
}

// ---------- DELETE event ----------
export async function deleteNoteApi({ token, id }) {
  return apiClient(`/notes/${id}`, {
    token,
    method: "DELETE",
  });
}
